export default __webpack_public_path__ + "static/media/4.e89abc3d.jpg";